import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";

export const Return = () => {
    document.title = "Qaytarma";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Nisyə", value: "/cash/credit" },
        { name: "Qatarma", value: "/cash/credit/return", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Qatarma</h2>
                    <p>Kassa proqramından borcu olan müştərinin qaytarma edən zaman ödənişin borcdan çıxılması və ya nəğd ödənilməsi seçimini etməlidir</p>
                    <img src="/images/cash/credit/return.gif" alt="Qatarma" />
                </article>
            </div>
        </div>
    );
};
